const emptyList = []
const resultFunction = (getAsset, activeAccountSyncedBalances) => {
  if (!activeAccountSyncedBalances) {
    return emptyList
  }

  return Object.entries(activeAccountSyncedBalances)
    .filter(([assetName, balance]) => !getAsset(assetName) && !balance.isZero)
    .sort(([, aBalance], [, bBalance]) => aBalance.toDefaultNumber() - bBalance.toDefaultNumber())
    .map(([assetName, balance]) => {
      return {
        displayTicker: assetName,
        displayName: assetName,
        name: assetName,
        balance,
      }
    })
}

const unsupportedNonZeroBalanceAssetsSelector = {
  id: 'unsupportedNonZeroBalanceAssets',
  resultFunction,
  dependencies: [
    //
    { module: 'assets', selector: 'getAsset' },
    { selector: 'inActiveAccount' },
  ],
}

export default unsupportedNonZeroBalanceAssetsSelector
